







































import Vue from 'vue'
import { functions }    from '@/db/firestore.ts';
import * as ping        from '@/lib/usage_ping';
import Modal            from '@/components/Modal.vue';

export default Vue.extend({
    data() {
        return {
            isBeingShared: false,
        }
    },
    props: ['deckId', 'showModal'],
    components: {
        Modal,
    },
    methods: {
        shareDeck() {
            const txtEmail = document.querySelector('#txtShareEmail');
            console.log(`Sharing deck ${this.id} to ${txtEmail['value']}...`);
            ping.send({ type: ping.DeckUsage.share, uid: this.currentUser.uid });
            this.isBeingShared = true;

            const shareDeckFn = functions.httpsCallable('shareDeck');
            shareDeckFn({ deckId: this.deckId, shareEmail: txtEmail['value']})
            .then(this.shareSuccess)
            .catch(this.shareCatch)
            .finally(() => {
                setTimeout(() => {
                    this.$emit('hideModal');
                    this.isBeingShared = false;
                }, 500);
            })
        },
        shareSuccess(res) {
            setTimeout(() => {
                this.$toast.open({
                    message: 'Sharing successful!',
                    type: 'success',
                    duration: 3000,
                    position: 'top-right'
                });
            }, 1500);
        },
        shareCatch(e) { this.toastAndError(this, 'There was an error sharing the deck.  Please try again', e); }
    }
})
